import '.x{position:fixed;}.ssr-plugin'
import '.c8{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.en{bottom:0px;}.ssr-plugin'
import '.gx{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.gy{z-index:998;}.ssr-plugin'
import '.gz{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a9{height:100vh;}.ssr-plugin'
import '.a5{width:100%;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.h0{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.h1{z-index:999;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.a6{justify-content:space-between;}.ssr-plugin'
import '.cf{padding:1.5rem;}.ssr-plugin'
import '.h2{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bu{flex:1;}.ssr-plugin'
import '.aj{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="x c8 bi bj en gx gy gz"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="x c8 a9 a5 ae h0 h1 i m"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="i n a6 cf h2 bn"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bu aj cf"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
